import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[pDynamicDialogHeader]',
})
export class DynamicDialogHeeader {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
